// Importaciones de React, React Router y las imágenes para las tarjetas.
import React from 'react';
import { Link } from 'react-router-dom';
import imagen1 from '../img/asistenteFinanciero.png';
import imagen2 from '../img/callCenter.png';
import imagen3 from '../img/Rh.png';
import imagen4 from '../img/mesaDeAyuda.png';

/**
 * Componente Casos de Uso.
 * Muestra diferentes casos de uso de la empresa, divididos en categorías,
 * utilizando tarjetas con un efecto de volteo (flip) al pasar el cursor.
 */
function Casos() {
  return (
    <div className="container mx-auto py-8">
      {/* Título principal de la sección. */}
      <h2 className="text-4xl font-bold text-center mb-4">CASOS DE USO</h2>
      <div className='linea'></div> {/* Línea decorativa. */}
      
      {/* Subsección: IA Generativa. */}
      <h2 className='text-center font-bold text-2xl'>INTELIGENCIA ARTIFICIAL GENERATIVA</h2>
      <div className="flex flex-wrap justify-center">
        
        {/* --- Tarjeta 1: Asistente financiero --- */}
        <div className="w-full md:w-1/2 lg:w-1/4 p-4">
          {/* La clase 'card' es el contenedor principal de la tarjeta con efecto flip. */}
          <div className="card rounded-10">
            {/* 'card-inner' es el elemento que rota. */}
            <div className="card-inner">
              {/* 'front' es la cara visible por defecto. */}
              <div className="front">
                <img src={imagen1} alt="Asistente Financiero" className="w-full h-full object-cover" />
              </div>
              {/* 'back' es la cara oculta, visible al hacer hover. */}
              <div className="back flex flex-col">
                <h2 className='text-2xl font-bold'>Asistente financiero</h2>
                <p className="text-white text-center">Impulsa tu negocio con asistente virtual en solo 30 días.</p>
                <Link to={'/consultas'}>
                  <button className="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 mt-5">
                    Conversemos
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <h3 className="text-center mt-2">Asistente financiero</h3>
        </div>

        {/* --- Tarjeta 2: Mesa de ayuda --- */}
        <div className="w-full md:w-1/2 lg:w-1/4 p-4">
          <div className="card rounded-10">
            <div className="card-inner">
              <div className="front">
                <img src={imagen2} alt="Mesa de Ayuda" className="w-full h-full object-cover" />
              </div>
              <div className="back flex flex-col">
                <h2 className='text-2xl font-bold'>Mesa de ayuda</h2>
                <p className="text-white text-center">Experimenta la eficiencia en atención con IA, automatiza tu atención de requerimientos de TI.</p>
                <Link to={'/consultas'}>
                  <button className="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 mt-5">
                    Conversemos
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <h3 className="text-center mt-2">Mesa de ayuda</h3>
        </div>
      </div>

      {/* Subsección: IA Aplicada. */}
      <h2 className='text-center font-bold text-2xl'>INTELIGENCIA ARTIFICIAL APLICADA</h2>
      <div className="flex flex-wrap justify-center">

        {/* --- Tarjeta 3: AI Document Intelligence --- */}
        <div className="w-full md:w-1/2 lg:w-1/4 p-4">
          <div className="card rounded-10">
            <div className="card-inner">
              <div className="front">
                <img src={imagen3} alt="AI Document Intelligence" className="w-full h-full object-cover" />
              </div>
              <div className="back flex flex-col">
                <h2 className='text-2xl font-bold'>AI Document Intelligence</h2>
                <p className="text-white text-center">Automatiza el proceso de extracción de información de documentos</p>
                <Link to={'/consultas'}>
                  <button className="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 mt-5">
                    Conversemos
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <h3 className="text-center mt-2">AI Document Intelligence</h3>
        </div>

        {/* --- Tarjeta 4: Blackberry Cylance --- */}
        <div className="w-full md:w-1/2 lg:w-1/4 p-4">
          <div className="card rounded-10">
            <div className="card-inner">
              <div className="front">
                <img src={imagen4} alt="Blackberry Cylance" className="w-full h-full object-cover" />
              </div>
              <div className="back flex flex-col">
                <h2 className='text-2xl font-bold'>Blackberry Cylance</h2>
                <p className="text-white text-center">Solución de seguridad para endpoints que utiliza inteligencia artificial para prevenir y detectar ataques cibernéticos.</p>
                <Link to={'/consultas'}>
                  <button className="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 mt-5">
                    Conversemos
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <h3 className="text-center mt-2">Blackberry Cylance</h3>
        </div>
      </div>
      
      {/* Botón final que enlaza a la página de consultas. */}
      <div className='w-screen flex justify-center'>
        <Link to={'/consultas'}>
          <button className="bg-blue-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700">
            Envíanos tu solicitud
          </button>
        </Link>
      </div>
    </div>
  );
}

// Exporta el componente para ser usado en otras páginas.
export default Casos;
